import api from '@/api/jobPosting'

const state = {

}

const actions = {
  getPostingFieldList (context, params) {
    return api.getPostingFieldList(params)
  },
  getPostingFieldDetail (context, { channelId, fieldType }) {
    return api.getPostingFieldDetail(channelId, fieldType)
  },
  savePostingField (context, { channelId, fieldType, fieldInfo }) {
    return api.savePostingField(channelId, fieldType, fieldInfo)
  },
  getPostingFieldOptions (context, { fieldTypeId, params }) {
    return api.getPostingFieldOptions(fieldTypeId, params)
  },
  searchPostingFieldOptions (context, params) {
    return api.searchPostingFieldOptions(params)
  },
  getCustomFieldMatchedPostingField (context, params) {
    return api.getCustomFieldMatchedPostingField(params)
  },
  getJobPostingTaskList (context, params) {
    return api.getJobPostingTaskList(params)
  },
  updateJobPostingTaskStatus (context, params) {
    return api.updateJobPostingTaskStatus(params)
  },
  checkJobPostingChannel (context, params) {
    return api.checkJobPostingChannel(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
